import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
type OfferBlockProps = {
  label: string;
  meta: string;
  id?: string;
  tone?: 'light' | 'dark';
};
export function OfferBlock({
  label,
  meta,
  id,
  tone = 'light'
}: OfferBlockProps) {
  const dark = tone === 'dark';
  return <div className="mx-auto flex w-full max-w-xl flex-col items-center" data-id="element-207" data-mp="skb3zquqgzli">
      <CtaButton id={id} label={label} data-id="element-208" data-mp="wm50dmxwbhfv" />
      <p className={`mt-4 text-center text-[15px] leading-relaxed ${dark ? 'text-white/80' : 'text-muted'}`} data-id="element-209" data-mp="wl3hiwan1qnl">{meta}</p>
      <p className={`mt-2 flex items-center justify-center gap-1.5 text-center text-sm font-medium ${dark ? 'text-radar' : 'text-radar-deep'}`} data-id="element-210" data-mp="iu8azqnm3ln6">
        <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-211" data-mp="1bineph1amhj7" />
        Your currency will be automatically converted according to your country.
      </p>
      <div className="mt-7" data-id="element-212" data-mp="2zm5g8nqm9vre">
        <Countdown tone={tone} data-id="element-213" data-mp="2zngj8lc8mzhg" />
      </div>
      <div className="mt-6 w-full" data-id="element-214" data-mp="2zkc9z9jx1djx">
        <ScarcityBar tone={tone} data-id="element-215" data-mp="2vld4nnu9very" />
      </div>
    </div>;
}